import type { FaireProductEntity } from "../../entity_types/product";

export const p_7s6hhr5ypm: FaireProductEntity = {
  token: "p_7s6hhr5ypm",
  type: "product",
  name: "Rhinestone Mini Bag Keychain Bag Charm",
  brandToken: "b_6hzxpxjqta",
  brandName: "Sparkling Extras",
  imageUrl:
    "https://cdn.faire.com/fastly/ca937ebdcc2ff998134726e3533bacc55ccbccfd302900d5a3c97c81f20bc535.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6bf34cf794b2114fafbdb96ae8390427c5fc379a82ee31c8b9328a325dbbc53a.jpeg",
    "https://cdn.faire.com/fastly/679b6260c0c5f812ef9dfc6706cace37b47a517e46169bfd4695c27dfba64766.jpeg",
    "https://cdn.faire.com/fastly/55658e2172007cdfb08423ef0f55f9e852093b37c882648817cc78b028a682fc.jpeg",
    "https://cdn.faire.com/fastly/1ed050a4295a5f907368ef0d1a38025858a01ffc29db91e8b9f6941db38a559b.jpeg",
    "https://cdn.faire.com/fastly/38f56166a38b450b611b7300115f1f53dfe972fd54763f5055cd2a60b06e31f9.jpeg",
    "https://cdn.faire.com/fastly/23474cb5347324995ab821de087f758c4d7c41af4a272233d9d1ef887fe8751d.jpeg",
    "https://cdn.faire.com/fastly/b3ac32c2ead98d1223723eb848764f1ec9fc78dd5c8f61eed1f9ca26f4fad8e2.jpeg",
    "https://cdn.faire.com/fastly/31c268bb329efec7b12e59d8423d1aba1e89f7127af8dc0e38ac27408e4539ad.jpeg",
  ],
  priceDollars: 6.91,
  description:
    "bag size: 6*5.8cm\nThis sparkly Mini Bag  keychain bag charm features an elegant bow silhouette fully embellished with rhinestones for a glamorous, eye-catching look. It adds a playful yet stylish accent to handbags, backpacks, or keys.\n\nDesigned with a soft strap and sturdy keyring, this Mini Bag charm is easy to attach and comfortable to carry. Available in multiple colors, it’s a perfect giftable accessory for boutiques, gift shops, and impulse-buy displays.",
  tags: [],
  msrpDollars: 13.83,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:41.445Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
